
<div class="container-fluid p-r-0 p-l-0">
    <header class="bg-c-162E50 c-fff">

        <div class="d-flex flex-column flex-sm-row align-items-center border-bottom p-5">

          <a [routerLink]="['/']" class="d-flex align-items-center text-dark text-decoration-none">
            <img src="../assets/images/logo.png" alt="logo" class="m-r-10 h-50px" />
            <span class="fs-4 text-decoration-none c-fff">
                Центр хірургії та трансплантології <br />
                ім. О.О.Шалімова 
            </span>
          </a>
    
          <!--nav for > then xs-->
          <nav class="d-sm-inline-flex d-none mt-0 mt-md-0 ms-auto">
            <div class="phone-box bi-telephone-fill"></div>
            <span class="me-3 py-2 text-dark text-decoration-none t-a-right w-s-nowrap">
              Он-лайн запис <br />
              <span *ngIf="assetsDataService.texts$ | async as texts">
                {{ texts.headerPhoneNumber }}
              </span>
            </span>
            <!-- <div class="qr-code-box">
              <img src="../assets/images/si-qr-code-3.png" alt="qr-code" class="m-r-10 h-48px" />
            </div> -->
          </nav>

          <!--nav for xs-->
          <nav class="d-xs-inline-flex d-sm-none mt-0 mt-md-0 ms-auto w-s-nowrap">
            <span class="phone-box bi-telephone-fill"></span>
            <span class="me-3 py-2 text-dark text-decoration-none t-a-right">
              <span *ngIf="assetsDataService.texts$ | async as texts">
                Он-лайн запис {{ texts.headerPhoneNumber }}
              </span>
            </span>
          </nav>

        </div>
      </header>

      <main class="si p-5">
        <router-outlet></router-outlet>
      </main>
</div>
